import { useEffect, useState } from 'react'
import { useUnMount } from 'shared/hooks'
import { hasSupport } from 'shared/polyfills/positioning'

import type { ActionsStore } from './store'

/**
 * css anchor class if has browser support
 */
export const useAnchorClass = ({
	anchorClassName,
	id = '',
	store
}: {
	anchorClassName: string
	id?: string
	store: ActionsStore
}): false | string => {
	const [cn, setCN] = useState<false | string>(false)

	useEffect(() => {
		if (!hasSupport) {
			return
		}

		const unsubscribe = store.openId.subscribe(current => {
			const isCurrentOpen = current === id

			if (isCurrentOpen) {
				return setCN(anchorClassName)
			}

			if (current) {
				setCN(false)
			}
		})

		return unsubscribe
	}, [id, store.openId, anchorClassName])

	useUnMount(() => {
		const isCurrentOpen = store.openId.value === id

		if (isCurrentOpen) {
			store.close()
		}
	})

	return cn
}
